var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsulta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C72ACC30-5B6C-42C0-884D-CA163F216410") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cart\\xE3o",
    transform: "translate(-944.000000, -152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component/-Itens-/-Cartao",
    transform: "translate(778.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Consulta",
    transform: "translate(167.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-paper",
    fill: "#E71037",
    stroke: "#E71037",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8823529,34 L4.11764706,34 C1.848,34 0,32.0943 0,29.75 L0,4.25 C0,1.9057 1.848,0 4.11764706,0 L23.8823529,0 C26.152,0 28,1.9057 28,4.25 L28,29.75 C28,32.0943 26.152,34 23.8823529,34 Z M4.11764706,1.7 C2.75552941,1.7 1.64705882,2.8441 1.64705882,4.25 L1.64705882,29.75 C1.64705882,31.1559 2.75552941,32.3 4.11764706,32.3 L23.8823529,32.3 C25.2444706,32.3 26.3529412,31.1559 26.3529412,29.75 L26.3529412,4.25 C26.3529412,2.8441 25.2444706,1.7 23.8823529,1.7 L4.11764706,1.7 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2222222,23 L6.77777778,23 C6.34844444,23 6,22.552 6,22 C6,21.448 6.34844444,21 6.77777778,21 L19.2222222,21 C19.6515556,21 20,21.448 20,22 C20,22.552 19.6515556,23 19.2222222,23 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2222222,29 L6.77777778,29 C6.34844444,29 6,28.552 6,28 C6,27.448 6.34844444,27 6.77777778,27 L19.2222222,27 C19.6515556,27 20,27.448 20,28 C20,28.552 19.6515556,29 19.2222222,29 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2222222,16 L6.77777778,16 C6.34844444,16 6,15.552 6,15 C6,14.448 6.34844444,14 6.77777778,14 L19.2222222,14 C19.6515556,14 20,14.448 20,15 C20,15.552 19.6515556,16 19.2222222,16 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2222222,9 L6.77777778,9 C6.34844444,9 6,8.552 6,8 C6,7.448 6.34844444,7 6.77777778,7 L19.2222222,7 C19.6515556,7 20,7.448 20,8 C20,8.552 19.6515556,9 19.2222222,9 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "search-(1)-2",
    transform: "translate(16.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-(1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 7.94545455,
    cy: 7.66666667,
    rx: 7.25454545,
    ry: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7105091,17.2956667 L14.0268364,12.5953333 C15.2310909,11.214 15.8909091,9.476 15.8909091,7.66666667 C15.8909091,3.43933333 12.3265091,0 7.94545455,0 C3.5644,0 0,3.43933333 0,7.66666667 C0,11.894 3.5644,15.3333333 7.94545455,15.3333333 C9.59016364,15.3333333 11.1574909,14.8546667 12.4975091,13.946 L17.2167636,18.682 C17.4140182,18.8796667 17.6793273,18.9886667 17.9636364,18.9886667 C18.2327455,18.9886667 18.4880364,18.8896667 18.6818364,18.7096667 C19.0936182,18.3273333 19.1067455,17.6933333 18.7105091,17.2956667 Z M7.94545455,2 C11.1837455,2 13.8181818,4.542 13.8181818,7.66666667 C13.8181818,10.7913333 11.1837455,13.3333333 7.94545455,13.3333333 C4.70716364,13.3333333 2.07272727,10.7913333 2.07272727,7.66666667 C2.07272727,4.542 4.70716364,2 7.94545455,2 Z",
    id: "Shape",
    fill: "#E71037",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsulta);
export default __webpack_public_path__ + "static/media/Consulta.24ca807b819d186bba538ff584ec7027.svg";
export { ForwardRef as ReactComponent };